import {
  VG_START_SIGNALR_CONN,
  VG_STARTED_SIGNALR_CONN,
  VG_STOP_SIGNALR_CONN,
  VG_STOPPED_SIGNALR_CONN,
  VG_RECONNECTING_SIGNALR_CONN,
  VG_RECONNECTED_SIGNALR_CONN,
  VG_FAILED_SIGNALR_CONN,
  VG_SET_MESSAGE,
  VG_REMOVE_MESSAGE,
  VG_REMOVE_ALL_MESSAGES,
  LOGOUT_EVENT,
} from "./actionTypes";

export const vgStartConnection = (connection) => {
  return {
    type: VG_START_SIGNALR_CONN,
    payload: { connection },
  };
};
export const vgReconnectingConnection = (data, status) => {
  return {
    type: VG_RECONNECTING_SIGNALR_CONN,
    payload: { data, status },
  };
};
export const vgReconnectedConnection = (data, status) => {
  return {
    type: VG_RECONNECTED_SIGNALR_CONN,
    payload: { data, status },
  };
};
export const vgStartedConnection = (data, status) => {
  return {
    type: VG_STARTED_SIGNALR_CONN,
    payload: { data, status },
  };
};
export const vgStopConnection = (connection) => {
  return {
    type: VG_STOP_SIGNALR_CONN,
    payload: { connection },
  };
};
export const vgStoppedConnection = () => {
  return {
    type: VG_STOPPED_SIGNALR_CONN,
    payload: {},
  };
};
export const vgFailedConnection = (data, status) => {
  return {
    type: VG_FAILED_SIGNALR_CONN,
    payload: { data, status },
  };
};

export const vgSetMessage = (data) => {
  return {
    type: VG_SET_MESSAGE,
    payload: { data },
  };
};
export const vgRemoveMessage = (id) => {
  return {
    type: VG_REMOVE_MESSAGE,
    payload: id,
  };
};
export const vgRemoveAllMessages = () => {
  return {
    type: VG_REMOVE_ALL_MESSAGES,
    payload: {},
  };
};

export const managerLogoutUser = (open = true) => {
  return {
    type: LOGOUT_EVENT,
    payload: { open },
  };
};
